import { map, Observable } from 'rxjs';
import { NbSelectModule } from '@nebular/theme';
import { Component, Input, OnInit } from '@angular/core';
import { KPI } from '../../../../@core/api';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PerimetersService, ScopeService } from '../../../../@core/utils';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-perimeter-selector',
  standalone: true,
  imports: [NbSelectModule, FormsModule, TranslateModule, AsyncPipe],
  templateUrl: './perimeter-selector.component.html',
  styleUrl: './perimeter-selector.component.scss'
})
export class PerimeterSelectorComponent implements OnInit {

  @Input() multiPerimeter: KPI.Perimeter;

  public selectedOption$: Observable<KPI.Perimeter>;
  public options$: Observable<KPI.Perimeter[]>;

  constructor(
    private perimetersService: PerimetersService,
    private scopeService: ScopeService,
  ) {}

  ngOnInit() {
    this.selectedOption$ = this.perimetersService.getSitePerimeterFocused(this.multiPerimeter);
    this.options$ = this.scopeService.perimeterTypes$.pipe(
      map((perimeterTypes) => [this.multiPerimeter].concat(
        this.multiPerimeter.sub_perimeters.filter((perimeter) =>
          perimeterTypes[perimeter.perimeter_type]?.perimeter_type_class === KPI.PerimeterTypeClass.CLASS_BUILDING
        ),
      )),
    );
  }

  public valueChanged(value) {
    this.perimetersService.setSitePerimeterFocused(this.multiPerimeter.id, value);
  }

}
